import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import type { Dispatch } from '@tmapy/redux';
import { useMessage, useSelectMessages } from '@tmapy/intl';

import {
  BtnBar,
  CtaBtn,
  Form,
  FormItem,
  Input,
  SecondaryBtn,
  Select,
  StickyFooter,
} from '@tmapy/style-guide';

import { useInput } from '../../hooks';
import type { ServiceOrdersListQuery } from '../../openapi/operations/serviceOrdersList';
import { setServiceOrderListFilter } from '../../redux/filter/actions';

import { SERVICE_ORDER_STATE } from '../constants';

import {
  serviceOrderBtnMessages,
  serviceOrderMessages,
  serviceOrderStateMessages,
} from './serviceOrderMessages';

type ServiceOrderFilterProps = {
  filters: ServiceOrdersListQuery;
  dispatch: Dispatch;
};

export const ServiceOrderFilter: React.FC<ServiceOrderFilterProps> = ({ filters, dispatch }) => {
  const formatMessage = useMessage();

  const name = useInput({
    name: 'name__icontains',
    initialValue: filters.name__icontains,
    label: formatMessage(serviceOrderMessages.name),
  });

  const stateItems = useSelectMessages(serviceOrderStateMessages, SERVICE_ORDER_STATE);
  const state = useInput({
    name: 'state',
    initialValue: filters.state,
    items: stateItems,
    label: formatMessage(serviceOrderMessages.state),
  });

  const handleClearBtnClick = useCallback(() => {
    [name, state].forEach((formItem) => formItem?.clear?.());

    dispatch(setServiceOrderListFilter({}));
  }, [name, state, dispatch]);

  const handleSubmit = () => {
    dispatch(
      setServiceOrderListFilter({
        name__icontains: name.value,
        state: state.value as ServiceOrdersListQuery['state'],
      }),
    );
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className='sg-u-vs-2'>
        <FormItem {...name}>
          <Input {...name} />
        </FormItem>
        <FormItem {...state}>
          <Select hasEmptyItem {...state} />
        </FormItem>
      </div>
      <StickyFooter>
        <BtnBar stretch>
          <CtaBtn type='submit'>
            <FormattedMessage {...serviceOrderBtnMessages.filterSubmit} />
          </CtaBtn>
          <SecondaryBtn isDanger onClick={handleClearBtnClick}>
            <FormattedMessage {...serviceOrderBtnMessages.clear} />
          </SecondaryBtn>
        </BtnBar>
      </StickyFooter>
    </Form>
  );
};
